import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

import {EndclientService} from '../shared/services/endclient.service';
import {UserService} from '../shared/services/user.service';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
@Component({
  selector: 'app-add-end-clients',
  templateUrl: './end-clients.component.html',
  styleUrls: ['./end-clients.component.scss']
})
export class AddEndClientsComponent implements OnInit {
   allEndClientList = [];
  allEndClientListTemp = [];
   updatedList = [];
  @Input() showAddEndClient: boolean;
  @Input('new-item-id') newItemId;
  @Input() name = '';
  endClientThreshold = 0;
  @ViewChild('myControl') myControl;
  @Input() state_id: any;
  Hposition: MatSnackBarHorizontalPosition = 'right';
  VPosition: MatSnackBarVerticalPosition = 'top';
  filteredOptions: Observable<string[]>;
  @Output("added") added = new EventEmitter<any>();

  constructor(private endclient: EndclientService, private toast: MatSnackBar, private user: UserService) { }

  ngOnInit(): void {

    this.endClientThreshold = (this.user.getEndClientThreshold()) * 1;
    this.endclient.getItems(false).subscribe((data) => {
      this.allEndClientList = data.data.Data?.map((data) => data.Name);
      this.allEndClientListTemp =  this.allEndClientList;
    });
  }

  loadItems = () => {
    let searchText = this.name;
    var Returndata = this.allEndClientListTemp;

    if (searchText == '') {
      return Returndata.map( (data) => {
        return {
          value: data.toLowerCase(),
          Name: data
        };
      });
    }
    else {
      this.updatedList = [];
      this.allEndClientList = [];
      Returndata.forEach((key) => {
        var result = + (this.method_internal_distance(searchText, key, 70, 70) / Math.min(searchText.length, key.length)).toFixed(3)
        if (result <= this.endClientThreshold) {
          this.updatedList.push(key);
        }
      });
      this.allEndClientList = this.updatedList;
    }
  }
  addEndClient(event){
    event.preventDefault();
    if (this.name.trim() == null){ return; }
    if (this.name.trim() == ''){return; }
    const props = {
      name: this.name
    };
    this.endclient.saveEndClient(props).subscribe(
      data => {
        if(data.apiCallStatus != 1) {
          this.showFailureToast("Invalid Request");
          return;
        }
        if(data.data.ErrorCode == 200){
          this.showConfirmationToast();
          this.showAddEndClient = false;         
          this.added.emit(data.data.Data);
        }else{
          this.showFailureToast(data.data.Message.Details);
          this.showAddEndClient = false;          
        }
      },
      err => {
        this.showFailureToast("Invalid Request");
        console.log(err);
      }
    );
  }

  showConfirmationToast() {
    this.toast.open('A new end client has been added', 'Got it', {
      duration: 2000, horizontalPosition: this.Hposition,
      verticalPosition: this.VPosition,
      panelClass: 'iwg-toast-text-white',
    });
  }

  showFailureToast(Message) {
    this.toast.open(Message, 'Got it', {
      duration: 2000, horizontalPosition: this.Hposition,
      verticalPosition: this.VPosition,
      panelClass: 'iwg-toast-text-white',
    });
  }

  method_internal_distance(s, t, block_size, max_distance) {
    s = s.toLocaleLowerCase();
    t = t.toLocaleLowerCase();
    let pure_levenshtein = false;
    let stop_execution = false;
    let sl = s.length;
    let tl = t.length;

    let i, i1, j, j1, k, half_sl, half_tl, cost;
    let distance, del, ins, subs, transp, block;
    let current_distance = 0;
    let min = 0;

    if (block_size == 0) {
      pure_levenshtein = true;
      block_size = 1;
    }

    if (sl == 0) {
      return tl;
    }
    if (tl == 0) {
      return sl;
    }

    if (sl == 1 && tl == 1 && s != t) {
      return 1;
    }
    sl++;
    tl++;
    const d = [];
    for (i = 0; i < tl; i++) {
      d[i * sl] = i;
    }

   
    for (i = 1; i < sl; i++) {
      d[i] = i;
      if (stop_execution) {
        break;
      }

      current_distance = 10000;
      for (j = 1; j < tl; j++) {
        cost = 1;
        if (s[i - 1] == t[j - 1]) {
          cost = 0;
        }

        half_sl = Math.floor((sl - 1) / 2);
        half_tl = Math.floor((tl - 1) / 2);

        block = block_size < half_sl || half_sl == 0 ? block_size : half_sl;
        block = block < half_tl || half_tl == 0 ? block : half_tl;

        while (block >= 1) {
          let swap1 = 1;
          let swap2 = 1;

          i1 = i - (block * 2);
          j1 = j - (block * 2);

          for (k = i1; k < (i1 + block); k++) {
            if (s[k] != t[k + block]) {
              swap1 = 0;
              break;
            }
          }

          for (k = j1; k < (j1 + block); k++) {
            if (t[k] != s[k + block]) {
              swap2 = 0;
              break;
            }
          }

          del = d[j * sl + i - 1] + 1;
          ins = d[(j - 1) * sl + i] + 1;
          min = del;

          if (ins < min) {
            min = ins;
          }

          if (!pure_levenshtein && i >= 2 * block && j >= 2 * block && swap1 == 1 && swap2 == 1) {
            transp = d[(j - block * 2) * sl + i - block * 2] + cost + block - 1;
            if (transp < min) {
              min = transp;
            }
            block = 0;
          }
          else if (block == 1) {
            subs = d[(j - 1) * sl + i - 1] + cost;
            if (subs < min) {
              min = subs;
            }
          }
          block--;
        }
        d[j * sl + i] = min;
        if (current_distance > d[j * sl + i]) {
          current_distance = d[j * sl + i];
        }
      }
      if (current_distance > max_distance) {
        stop_execution = true;
      }
    }
    distance = d[sl * tl - 1];
    if (stop_execution) {
      distance = current_distance;
    }

    return distance;
  }

}
